/* ============================================================
   ListView — 노션 리스트 뷰 스타일의 컴팩트 행 목록
   - 행: title 좌측, 주요 속성(select 칩/담당자/날짜) 우측 정렬
   - 행 클릭 → 행 페이지(/page/:id) 이동
   ============================================================ */
import { Link } from 'react-router-dom';
import { optClass, avaColor, fmtShort } from './viewPipeline';
import { personNames } from './computeValue';

export default function ListView({ columns, rows, peopleById, createRow }) {
  const selectCols = columns.filter((c) => c.type === 'select').slice(0, 2);
  const personCol = columns.find((c) => c.type === 'person');
  const dateCol = columns.find((c) => c.type === 'date');

  return (
    <div className="lst">
      {rows.map((r) => {
        // person: user id 배열(신규)/평문(레거시) 모두 이름으로 해석
        const pNames = personCol ? personNames(r.properties?.[personCol.key], peopleById) : [];
        const date = dateCol ? r.properties?.[dateCol.key] : '';
        return (
          <Link className="lst-row" key={r.page_id} to={`/page/${r.page_id}`}>
            <span className="lst-title">
              <span className="lst-emoji">{r.icon || '📄'}</span>
              {r.title || '제목 없음'}
            </span>
            <span className="lst-props">
              {selectCols.map((c) => {
                const v = r.properties?.[c.key];
                if (!v) return null;
                return (
                  <span key={c.key} className={`tag ${optClass(c, v)}`}>{v}</span>
                );
              })}
              {pNames.length > 0 && (
                <span className="person">
                  <span className="mav" style={{ background: avaColor(pNames[0]) }}>{pNames[0][0]}</span>
                  {pNames.join(', ')}
                </span>
              )}
              {date && <span className="lst-date">{fmtShort(date)}</span>}
            </span>
          </Link>
        );
      })}
      <button className="newrow" onClick={() => createRow()}>＋ 새로 만들기</button>
    </div>
  );
}
